import { proxyMessageContracts as e } from "./contracts.js";
import { PROXY_EXTERNAL_MESSAGE_TYPE as t, ProxyBackgroundMessageSchema as n } from "./transport.js";
//#region src/proxy-message/external.ts
async function r(r, i, a = 5e3) {
	let { promise: o, resolve: s, reject: c } = Promise.withResolvers(), l = crypto.randomUUID(), u, d = (t) => {
		t.source === window && t.origin === window.origin && n.refine((e) => e.id === l).safeParseAsync(t.data).then(({ success: t, data: n }) => {
			if (t) {
				if (window.removeEventListener("message", d), u !== void 0 && clearTimeout(u), n.success) {
					let t = e[r].responseSchema.safeParse(n.result);
					if (!t.success) {
						c(/* @__PURE__ */ Error(`[ProxyMessage] invalid response for ${r}`));
						return;
					}
					s(t.data);
				} else c(/* @__PURE__ */ Error(`[ProxyMessage] got an error response for request ${l} ${r} ${JSON.stringify(n.error)}`));
			}
		});
	};
	return window.addEventListener("message", d), window.postMessage({
		id: l,
		handler: r,
		params: i,
		type: t
	}, window.origin), a !== void 0 && (u = setTimeout(() => {
		window.removeEventListener("message", d), c(`Message ${l} to ${r} timed out`);
	}, a)), o;
}
var i = (e = 6e4) => new Promise((t, n) => {
	let i = !1, a = setTimeout(() => {
		i = !0, n(`Proxy message channel not ready after ${e}ms`);
	}, e), o = () => {
		r("ping", void 0, 100).then(() => {
			i || (i = !0, clearTimeout(a), t());
		}).catch(() => {
			i || setTimeout(o, 100);
		});
	};
	o();
});
//#endregion
export { r as dispatchProxyMessage, i as waitForProxyMessageChannelReady };
